import request from '../utils/request'


export function index(params) {
  	return request({
  	  url: '/dailyTreatmentProductLists',
  	  method: 'get',
      params
  	})
  }
  export function inventory(params) {
    return request({
      url: '/dailyTreatmentProductLists/inventory',
      method: 'get',
      params
    })
  }
  
export function showList(params) {
    return request({
      url: `/dailyTreatmentProductLists/showlist`,
      method: 'get',
      params
    })
  }

  export function store(data) {
    return request({
      url: '/dailyTreatmentProductLists',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/dailyTreatmentProductLists/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/dailyTreatmentProductLists/${id}`,
      method: 'delete',
    })
  }
